import { useFeatureFlag } from '../../app/_providers/ExperimentationProvider.client'

// Skip ineligible users so they never record a decision (exposure) for this flag.
export const useEmbroideryV2Flag = ({ skip }: { skip: boolean }): boolean => {
  const decision = useFeatureFlag<'true' | 'false'>({
    key: 'enable-embroidery-multiplacement',
    controlVariant: 'false',
    ifAccessedPriorToDecisionInitialization: 'lock-pageview-to-controlVariant',
    skip,
  })

  return decision === 'true'
}
